var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('XSelect',_vm._g(_vm._b({attrs:{"options":_vm.options,"value":_vm.value,"spin":_vm.spin},on:{"refresh":_vm.loadOptions}},'XSelect',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }